import { render } from "./DockWeatherIcon.vue?vue&type=template&id=0ddeb568&scoped=true"
import script from "./DockWeatherIcon.vue?vue&type=script&lang=js"
export * from "./DockWeatherIcon.vue?vue&type=script&lang=js"

import "./DockWeatherIcon.vue?vue&type=style&index=0&id=0ddeb568&scoped=true&lang=css"

import exportComponent from "/var/www/service/service-cp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ddeb568"]])

export default __exports__